(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["narda-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-narda-ugc-videos]');

    const muteOtherVideos = (activeVideo) => {
      document.querySelectorAll('[data-narda-ugc-video]').forEach((video) => {
        if (video === activeVideo) return;
        video.muted = true;
        video.classList.remove('is-sound-on');
        video.closest('.narda-ugc-videos__item')?.classList.remove('is-sound-on');
        video
          .closest('.narda-ugc-videos__item')
          ?.querySelector('[data-narda-ugc-toggle]')
          ?.setAttribute('aria-label', 'Activar audio');
      });
    };

    const primeFirstFrame = (video) => {
      video.addEventListener(
        'loadedmetadata',
        () => {
          if (video.currentTime === 0) {
            try {
              video.currentTime = 0.001;
            } catch (error) {
              // Some browsers block seeking until enough video data is available.
            }
          }
        },
        { once: true }
      );

      video.addEventListener('loadeddata', () => video.classList.add('is-ready'), { once: true });
      video.load();
    };

    const playVideo = (video) => {
      if (!video.dataset.autoplay) return;
      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    sections.forEach((section) => {
      const videos = section.querySelectorAll('[data-narda-ugc-video]');

      videos.forEach((video) => {
        const item = video.closest('.narda-ugc-videos__item');
        const toggle = item?.querySelector('[data-narda-ugc-toggle]');

        primeFirstFrame(video);

        item?.addEventListener('click', () => {
          const shouldUnmute = video.muted;

          muteOtherVideos(video);
          video.muted = !shouldUnmute;
          video.classList.toggle('is-sound-on', shouldUnmute);
          item.classList.toggle('is-sound-on', shouldUnmute);
          toggle?.setAttribute('aria-label', shouldUnmute ? 'Silenciar audio' : 'Activar audio');
          video.play().catch(() => {});
        });
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;

              if (entry.isIntersecting) {
                playVideo(video);
                return;
              }

              if (!video.classList.contains('is-sound-on')) {
                video.pause();
              }
            });
          },
          { threshold: 0.35, rootMargin: '120px 0px' }
        );

        videos.forEach((video) => observer.observe(video));
      } else {
        videos.forEach(playVideo);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
